import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "searchbox",
  class: "card"
}
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row mb-3 gx-3 align-items-center" }
const _hoisted_4 = { class: "col-auto" }
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = { class: "col-auto" }
const _hoisted_7 = { class: "input-group" }
const _hoisted_8 = {
  key: 0,
  style: {"margin-left":"3em"}
}
const _hoisted_9 = { class: "card-header" }
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = {
  class: "card-subtitle",
  style: {"margin-bottom":"0.5em"}
}
const _hoisted_12 = {
  key: 0,
  class: "float-right"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 2,
  style: {"font-style":"italic"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_loading_spinner = _resolveComponent("loading-spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "card-header row" }, "Filter", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.get_incidents && _ctx.get_incidents(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "input-group-text" }, "From", -1)),
                _createVNode(_component_datepicker, {
                  modelValue: _ctx.pickerStartDate,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pickerStartDate) = $event)),
                  onfocusout: _ctx.push_end_date(),
                  typeable: "",
                  inputFormat: _ctx.dateFormat,
                  class: "input-sm form-control",
                  minimumView: "time"
                }, null, 8, ["modelValue", "onfocusout", "inputFormat"])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "input-group-text" }, "To", -1)),
                _createVNode(_component_datepicker, {
                  modelValue: _ctx.pickerEndDate,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pickerEndDate) = $event)),
                  "lower-limit": _ctx.pickerStartDate,
                  typeable: "",
                  inputFormat: _ctx.dateFormat,
                  class: "input-sm form-control",
                  minimumView: "time"
                }, null, 8, ["modelValue", "lower-limit", "inputFormat"])
              ])
            ])
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "form-row" }, [
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary"
            }, "Update Results")
          ], -1))
        ], 32)
      ])
    ]),
    _withDirectives(_createVNode(_component_loading_spinner, null, null, 512), [
      [_vShow, _ctx.isLoading]
    ]),
    (_ctx.incidents.length == 0 && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, "No incidents match these filters."))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.incidents, (incident) => {
      return (_openBlock(), _createElementBlock("div", {
        key: incident,
        class: _normalizeClass(["card incident-card", {
      ongoing: incident.EndTime === null,
      'is-alert': incident.Alert,
    }])
      }, [
        _createElementVNode("h4", _hoisted_9, _toDisplayString(incident.SensorName), 1),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("h4", _hoisted_11, [
            _createTextVNode(_toDisplayString(incident.IncidentType) + " ", 1),
            (incident.EndTime === null)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Still Active"))
              : _createCommentVNode("", true)
          ]),
          (incident.StartTime == incident.EndTime)
            ? (_openBlock(), _createElementBlock("p", _hoisted_13, "At: " + _toDisplayString(_ctx.formatTime(incident.StartTime)), 1))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (incident.StartTime !== null)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, "From: " + _toDisplayString(_ctx.formatTime(incident.StartTime)), 1))
                  : _createCommentVNode("", true),
                (incident.EndTime !== null)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, "Until: " + _toDisplayString(_ctx.formatTime(incident.EndTime)), 1))
                  : _createCommentVNode("", true)
              ], 64)),
          (incident.WorstValue !== null)
            ? (_openBlock(), _createElementBlock("p", _hoisted_16, " Worst value: " + _toDisplayString(incident.WorstValue.toFixed(1)) + " at " + _toDisplayString(_ctx.formatTime(incident.WorstValueTime)), 1))
            : _createCommentVNode("", true)
        ])
      ], 2))
    }), 128))
  ], 64))
}